import {connect} from "react-redux"
import LoginView from "../components/LoginView"
import {routerActions} from "react-router-redux"
import {ACTION_USER_LOGGING_IN} from '../../../constants'

function mapStateToProps(state, ownProps) {

  const loading = state.user.loading
  const error = state.user.error

  return {
    loading,
    error,
  }
}

const mapDispatchToProps = {
  login: (data) => {
    return {
      type: ACTION_USER_LOGGING_IN,
      payload: data
    }
  },
  replace: routerActions.replace

}


export default connect(mapStateToProps, mapDispatchToProps)(LoginView)



// WEBPACK FOOTER //
// ./src/routes/Login/containers/LoginContainer.js